<template>
	<div class="margin-left">
		<div class="flex align-center">
			<div class="surplus flex flex-direction">
				<p class="text-lg text-333 padding-left padding-top padding-bottom-sm text-left solid-bottom">我的积分剩余</p>
				<div class="flex flex-sub flex-direction align-center justify-center">
					<p class="text-theme num ">{{integral||0}}</p>
					<p class="text-theme text-sm consume margin-top-sm pointer" @click="godetail('integralrecord')">消耗记录</p>
				</div>
			</div>
			<div class="scene flex flex-direction margin-left-sm">
				<p class="text-lg text-333 padding-left padding-top padding-bottom-sm text-left solid-bottom">积分使用场景</p>
				<div class="flex flex-sub">
					<div class="flex flex-sub flex-direction align-center justify-center">
						<img class="block-38" src="../../../assets/img/integral/sticky.png" >
						<p class="text-666 text-sm margin-top-sm">查看和置顶信息</p>
					</div>
					<div class="flex flex-sub flex-direction align-center justify-center">
						<img class="block-38" src="../../../assets/img/integral/advert.png" >
						<p class="text-666 text-sm margin-top-sm">广告申请发布</p>
					</div>
					<div class="flex flex-sub flex-direction align-center justify-center">
						<img class="block-38" src="../../../assets/img/integral/convert.png" >
						<p class="text-666 text-sm margin-top-sm">兑换培训课程</p>
					</div>
				</div>
			</div>
		</div>
		<div class="flex align-center justify-between obtain-inter padding-lr margin-top-sm">
			<p class="text-lg">积分获取场景</p>
			<p class="obtain text-theme pointer" @click="godetail('integralrecord')">获取记录</p>
		</div>
		<div class="allwidth">
			<el-row :gutter="10">
				<el-col :span="12">
					<div class="flex align-center justify-between bg-white obtain-item padding-lr-sm margin-top-sm" @click="godetail('integralrecharge')">
						<div class="flex">
							<img class="block-55 margin-right-xs" src="../../../assets/img/integral/recharge.png" >
							<div class="flex flex-direction justify-between align-start">
								<p>在线充值</p>
								<p>每积分一元钱，多冲更优惠</p>
							</div>
						</div>
						<p class="btn bg-theme text-white pointer">去充值</p>
					</div>
				</el-col>
				<el-col :span="12">
					<div class="flex align-center justify-between bg-white obtain-item padding-lr-sm margin-top-sm" @click="godetail('share')">
						<div class="flex">
							<img class="block-55 margin-right-xs" src="../../../assets/img/integral/invitation.png" >
							<div class="flex flex-direction justify-between align-start">
								<p>邀请好友</p>
								<p>每邀请一位好友注册，可获{{integral_share}}积分</p>
							</div>
						</div>
						<p class="btn bg-theme text-white pointer">去邀请</p>
					</div>
				</el-col>
				<el-col :span="12">
					<div class="flex align-center justify-between bg-white obtain-item padding-lr-sm margin-top-sm" @click="godetail('task')">
						<div class="flex">
							<img class="block-55 margin-right-xs" src="../../../assets/img/integral/task.png" >
							<div class="flex flex-direction justify-between align-start">
								<p>做任务赚积分</p>
								<p>每天来这里做小任务获得积分</p>
							</div>
						</div>
						<p class="btn bg-theme text-white pointer">做任务</p>
					</div>
				</el-col>
			</el-row>
		</div>
		<p class="platform margin-top-sm text-sm text-999">如有疑问请联系平台客服：<span class="text-theme">400-212-22</span></p>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				phone:'',
				integral:0,
				integral_share:'',
			};
		},
		created() {
			this.getMyIntegral()
			this.getTaskIntegral()
		},
		methods: {
			
			//通知center 跳转对应页面
			godetail(index){
				let type = {
					type:index,
					typeone:'integral'
				}
				this.$emit('gettype',type)
			},
			//获取我的积分
			getMyIntegral(){
				this.ajax('get', '/api/integral/getMyIntegral', {},res => {
					this.integral = res.data.integral
				})
			},
			//获取任务积分
			getTaskIntegral(){
				this.ajax('get', '/api/system/getTaskIntegral', {},res => {
					console.log(res.data);
					this.integral_share = res.data.integral_share
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.surplus{
		width: 321px;
		height: 221px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
		border-radius: 20px;
		.num{
			font-size: 42px;
		}
		.consume{
			width: 104px;
			height: 35px;
			line-height: 35px;
			background: #FFFFFF;
			border: 1px solid #09827B;
			border-radius: 18px;
		}
	}
	.scene{
		width: 579px;
		height: 221px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
		border-radius: 20px;
	}
	
	.block-38{
		width: 38px;
		height: 38px;
	}
	.block-55{
		width: 55px;
		height: 55px;
	}
	.obtain-inter{
		width: 918px;
		height: 73px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
		border-radius: 20px;
	}
	.obtain{
		width: 104px;
		height: 35px;
		line-height: 35px;
		background: #FFFFFF;
		border: 1px solid #09827B;
		border-radius: 18px;
	}
	.allwidth{
		width: 918px;
	}
	.obtain-item{
		width: 450px;
		height: 114px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
		border-radius: 20px;
	}
	.platform{
		width: 918px;
		height: 73px;
		line-height: 73px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
		border-radius: 20px;
	}
	.btn{
		width: 106px;
		height: 38px;
		line-height: 38px;
		border-radius: 19px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/integral/index.vue